module.exports = __webpack_public_path__ + "media/images/birds-f56fdaee7ec08b9882ae2df160672b8b.jpg";